// 3rd party libs
import React, { useEffect, useMemo, useState } from 'react';
import cs from 'classnames';

// local modules
import styles from './RolePlate.module.scss';
import { RolesLowerCase } from '../../../enums/ROLES';
import { Tooltip } from '@material-ui/core';

type TRolePlate = {
  userRole: string;
  className?: string;
  style?: any;
  firstUpper?: boolean;
};

const RolePlate: React.FC<TRolePlate> = ({ userRole, className, style, firstUpper }) => {
  const [enableToolTip, setEnableTooltip] = useState(false);
  const renderRole = useMemo(() => {
    if (userRole === RolesLowerCase.ORGANIZATION_ADMIN || userRole === 'oa') {
      return 'OA';
    } else if (userRole === RolesLowerCase.SUPER_ADMIN) {
      return 'SA';
    } else if (userRole?.toLocaleLowerCase() === 'sa') {
      return 'SA';
    } else if (userRole?.toLocaleLowerCase() === 'group') {
      return 'Group';
    } else if (userRole?.toLocaleLowerCase() === 'subgroup') {
      return 'Subgroup';
    } else if (firstUpper && userRole) {
      return userRole.charAt(0).toUpperCase() + userRole.slice(1);
    } else if (userRole) {
      return userRole;
    } else {
      return 'no role';
    }
  }, [userRole]);

  useEffect(() => {
    if (userRole === RolesLowerCase.SUPER_ADMIN || userRole?.toLocaleLowerCase() === 'sa') {
      setEnableTooltip(true);
    }
  }, [userRole]);

  return enableToolTip ? (
    <Tooltip placement="left" arrow title={userRole}>
      <div className={cs(styles.rolePlate, styles[userRole?.replace(/ /g, '').toLowerCase()], className)} style={style}>
        {renderRole}
      </div>
    </Tooltip>
  ) : (
    <div className={cs(styles.rolePlate, styles[userRole?.replace(/ /g, '').toLowerCase()], className)} style={style}>
      {renderRole}
    </div>
  );
};

export default RolePlate;
